// extracted by mini-css-extract-plugin
export var chatHtmlText = "_s2-2";
export var chatLink = "_s2-0";
export var chatText = "_s2-1";